var storage = require('storage')

module.exports = Em.Route.extend({
    model: function() {
        return this.modelFor('bank_account')
    },

    afterModel: function(model) {
        // Check if we have a payload in local storage
        var rawBankStatementData = storage('bank-statement-upload')

        if (typeof rawBankStatementData === 'string') {
            try {
                var parsedBankStatement = JSON.parse(rawBankStatementData)
                model.set('payload', parsedBankStatement)
                storage.remove('bank-statement-upload')
            } catch(e) {
                console.warn('Failed to process data', e)
            }
        }

        if (!model.get('payload')) {
            this.replaceWith('bank_import', model)
        }
    },

    resetController: function(controller, isExiting) {
        this._super.apply(this, arguments)

        if (isExiting) {
            controller.set('columnMapping', null)
        }
    }
})
